export const services = [
  {
    title: "Global Export Services",
    description:
      "We provide reliable global export services with instant sourcing, premium packaging, and fast delivery. Our wide portfolio helps international buyers receive fresh and high-quality products at competitive prices."
  },
  {
    title: "Import Solutions for Indian Businesses",
    description:
      "We offer smooth and efficient import solutions, managing sourcing, documentation, and logistics for Indian businesses. Our transparent process helps companies access global products without complications."
  },
  {
    title: "Fresh Agro Products Supply",
    description:
      "We export high-quality fresh agro products sourced directly from farms. Instant processing and packaging ensure freshness, nutritional value, and long shelf life for global buyers."
  },
  {
    title: "Processed Food Export",
    description:
      "We supply a wide range of processed and packaged food items, following strict hygiene and export standards. Our products deliver authentic Indian taste with consistent quality."
  },
  {
    title: "Quality Control & Packaging",
    description:
      "Our specialized quality control team ensures every product meets international standards. Advanced packaging solutions help maintain freshness and safety during global transportation."
  },
  {
    title: "Customized Product Sourcing",
    description:
      "We offer customized sourcing services for businesses needing specific products from India. With a strong supplier network, we provide high-quality materials at competitive prices."
  },
  {
    title: "Logistics & Export Documentation",
    description:
      "We handle complete logistics and export documentation, including customs clearance and freight forwarding. Our efficient process guarantees smooth and timely delivery across the globe."
  }
];
